<template>
  <div class="wrapper">
    <h2 class="title">Trade history for {{ assetName }}</h2>
    <table class="table" v-if="saleHistory && saleHistory.length > 0">
      <thead>
        <tr>
          <th>Date & time</th>
          <th>Price per unit</th>
          <th>Amount</th>
          <th>Total price</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sale in sortedSaleHistory">
          <td> {{ tradeDate(sale) }}</td>
          <td> {{ pricePerUnit(sale) }} EVR</td>
          <td> {{ sale.assetAmount }} {{ assetName }}</td>
          <td> {{ sale.price }} EVR </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <p>There were no trades for this asset.</p>
    </div>
  </div>
</template>

<script>

import dayjs from 'dayjs';

export default {
  name: 'asset-sale-history',
  props: ['saleHistory', 'assetName'],
  computed: {
    sortedSaleHistory() {
      return this.saleHistory
        ? [...this.saleHistory].sort((t1, t2) => t2.id - t1.id)
        : [];
    }
  },
  methods: {
    tradeDate(trade) {
      return trade.timestamp !== 0
        ? dayjs.unix(trade.timestamp).format('YYYY-MM-DD HH:MM')
        : '-';
    },
    pricePerUnit(trade) {
      return Math.round(trade.price / trade.assetAmount * 100000) / 100000;
    },
  },
};

</script>

<style scoped>

.table {
  width: 100%;
}

.title {
  font-size: 1.5rem;
}

.wrapper {
  margin-top: 16px;
}

</style>
